<template>
  <div>
    <Navbar></Navbar>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <div class="content">
            <div class="header is-flex is-justify-content-space-between sticky-header">
              <div>
                <h4 class="title is-4">
                  {{ $t('Management.Mode') }}
                </h4>
                <h6 class="subtitle is-6 has-text-grey" v-if="getMngMode == 'vets' && !creating">
                  {{ $t('Management.ManageVets') }}
                </h6>
                <h6 class="subtitle is-6 has-text-grey" v-if="getMngMode == 'managers' && !creating">
                  {{ $t('Management.ManageManagers') }}
                </h6>
                <h6 class="subtitle is-6 has-text-grey" v-if="getMngMode == 'customers' && !creating">
                  {{ $t('Management.VisualizeCustomers') }}
                </h6>
                <h6 class="subtitle is-6 has-text-grey" v-if="getMngMode == 'appointments' && !creating">
                  {{ $t('Management.VisualizeAppointments') }}
                </h6>
                <h6 class="subtitle is-6 has-text-grey" v-if="getMngMode == 'products' && !creating">
                  {{ $t('Management.ManageProducts') }}
                </h6>
                <h6 class="subtitle is-6 has-text-grey" v-if="getMngMode == 'appointments_access_codes' && !creating">
                  {{ $t('Management.VisualizeAppointmentsAccessCodes') }}
                </h6>
                <h6 class="subtitle is-6 has-text-grey" v-if="getMngMode == 'vets_availability' && !creating">
                  {{ $t('Management.VisualizeVetsAvailability') }}
                </h6>
                <h6 class="subtitle is-6 has-text-grey" v-if="getMngMode == 'logs' && !creating">
                  {{ $t('Management.VisualizeLogs') }}
                </h6>
              </div>
              <div>
                <button class="button is-primary" @click="iniCreating"
                  v-if="getMngMode == 'vets' && !creating"><strong>{{ $t('Management.NewVet') }}</strong></button>
                <button class="button is-primary" @click="iniCreating"
                  v-if="getMngMode == 'managers' && !creating"><strong>{{ $t('Management.NewManager') }}</strong></button>
                <button class="button is-primary" @click="exportVetAvailTable"
                  v-if="getMngMode == 'vets_availability'"><strong>{{ $t('Management.ExportToExcel') }}</strong>
                </button>
              </div>
            </div>
            <div class="content-body scroll-area">
              <!-- Customer name search -->
              <div
              v-if="getMngMode == 'customers' && !creating"
              class="field is-horizontal is-flex-direction-column-mobile mb-2"
            >
                <div class="field-body">
                  <div class="field is-expanded">
                    <div class="control is-expanded">
                      <input
                        v-model="customerNameSearch"
                        class="input"
                        type="text"
                        :placeholder="$t('CustomerData.FilterByName')"
                      />
                    </div>
                  </div>

                  <!-- RESET BUTTON -->
                  <div class="field">
                    <div class="control">
                      <button
                        class="button is-light"
                        @click="customerNameSearch = ''"
                      >
                        {{ $t('General.ResetFilter') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Vets, Managers and Customers list  -->
              <div class="table-container mb-2 " v-if="getMngMode != 'appointments' &&
                                                       getMngMode != 'products' &&
                                                       getMngMode != 'appointments_access_codes' &&
                                                       getMngMode != 'vets_availability' &&
                                                       getMngMode != 'logs' &&
                                                       !creating" style="max-height: 500px; overflow-y: auto;">
                <table class="table">
                  <thead>
                    <tr>
                      <th>{{ $t('UserData.Id') }}</th>
                      <th v-if="getMngMode != 'customers'">{{ $t('UserData.Photo') }}</th>
                      <th class="">{{ $t('UserData.Name') }}</th>
                      <th class="">{{ $t('UserData.Email') }}</th>
                      <th class="" v-if="getMngMode != 'managers'">{{ $t('UserData.Phone') }}</th>
                      <th class="" v-if="getMngMode == 'customers'">{{ $t('CustomerData.Address') }}</th>
                      <th class="" v-if="getMngMode == 'vets'">{{ $t('VetData.Specialty') }}</th>
                      <th class="" v-if="getMngMode == 'customers'">{{ $t('CustomerData.VATNumber') }}</th>
                      <th class="">{{ $t('UserData.Status') }}</th>
                      <th class="">{{ $t('UserData.StatusDate') }}</th>
                      <th v-if="getMngMode != 'customers'">{{ $t('General.Operations') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user of filteredUsers" :key="user.user_id">
                      <UserTableRow :user-data="user" :parentShowCustomerData="showCustomerData"></UserTableRow>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Appointments list  -->
              <!-- Vet Filter -->
              <div v-if="getMngMode == 'appointments' && !getShowingAppointmentData" class="field is-grouped mb-2">
                
                <div class="field is-horizontal is-flex-direction-column-mobile">
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <select v-model="filterVetUserId" required class="select is-fullwidth px-3 is-size-6 mobile-select">
                          <option value="" disabled selected>{{ $t('Management.SelectVet') }}</option>
                          <option v-for="vet of getUsers" :key="vet.user_id" :value="vet.user_id">{{ vet.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Date Range Filter -->
              <div v-if="getMngMode == 'appointments' && !getShowingAppointmentData" class="field is-horizontal is-flex-direction-column-mobile mb-2">
                <div class="field-label is-normal">
                  <label class="label">{{ $t('General.From') }}</label>
                </div>
                <div class="field-body">
                  <div class="control">
                    <VueDatePicker id="filter_start_date" v-model="filterStartDate" :placeholder="$t('General.PleaseSelectDate')"
                    model-type="yyyy-MM-dd" auto-apply :min-date="new Date(1950, 0, 1)" :max-date="maxDate"
                    :enable-time-picker="false" prevent-min-max-navigation format="yyyy-MM-dd"/> 
                  </div>
                </div>
                <div class="field-label is-normal">
                  <label class="label">{{ $t('General.To') }}</label>
                </div>
                <div class="field-body">
                  <div class="control">
                    <VueDatePicker id="filter_end_date" v-model="filterEndDate" :placeholder="$t('General.PleaseSelectDate')"
                    model-type="yyyy-MM-dd" auto-apply :min-date="new Date(1950, 0, 1)" :max-date="maxDate"
                    :enable-time-picker="false" prevent-min-max-navigation format="yyyy-MM-dd"/>
                  </div>
                </div>
                <div class="field-body">
                  <div class="control">
                    <button @click="resetFilter" class="button is-light">{{ $t('General.ResetFilter') }}</button>
                  </div>
                </div>
              </div>
              
              <div class="table-container mb-2 " v-if="getMngMode == 'appointments' && !getShowingAppointmentData" style="max-height: 365px; overflow-y: auto;">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="">{{ $t('AppointmentData.Appointment') }}</th>
                      <th class="">{{ $t('AppointmentData.Vet') }}</th>
                      <th class="">{{ $t('AppointmentData.Customer') }}</th>
                      <th class="">{{ $t('AppointmentData.Pet') }}</th>
                      <th v-if = 'considerInsurance' class="">{{ $t('AppointmentData.Policy') }}</th>
                      <th class="">{{ $t('AppointmentData.Price') }}</th>
                      <th class="">{{ $t('AppointmentData.Status') }}</th>
                      <th class="">{{ $t('AppointmentData.StatusTime') }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="appointment of filteredAppointments" :key="appointment.appointment_id">
                      <MngAppointmentRecordTableRow :appointment-data="appointment"></MngAppointmentRecordTableRow>
                    </tr>
                  </tbody>
                </table>
              </div>
              <AppointmentDataForm v-if="getMngMode == 'appointments' && getShowingAppointmentData"></AppointmentDataForm>
              
              <!-- Export to Excel -->
              <button @click="exportAppointmentsToExcel" v-if="getMngMode == 'appointments' && !getShowingAppointmentData" class="button is-primary">
                {{ $t('Management.ExportToExcel') }}
              </button>

              <!-- Products list  -->
              <table class="table" v-if="getMngMode == 'products'">
                <thead>
                  <tr>
                    <th>{{ $t('ProductData.Id') }}</th>
                    <th class="">{{ $t('ProductData.Designation') }}</th>
                    <th class="">{{ $t('ProductData.Price') }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product of getProducts" :key="product.product_id">
                    <ProductTableRow :product-data="product"></ProductTableRow>
                  </tr>
                </tbody>
              </table>

              <!-- List of Appointments Acess Codes  -->
              <table class="table" v-if="useAppointsAccessCodes && getMngMode == 'appointments_access_codes'">
                <thead>
                  <tr>
                    <th>{{ $t('AppointmentsAccessCodesData.ValidFrom') }}</th>
                    <th class="">{{ $t('AppointmentsAccessCodesData.ValidTo') }}</th>
                    <th class="">{{ $t('AppointmentsAccessCodesData.Code') }}</th>
                    <th class="">{{ $t('AppointmentsAccessCodesData.IncludedAppointments') }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="appointments_access_code of getAppointmentsAccessCodes" :key="appointments_access_code.valid_from">
                    <AppointmentsAccessCodesTableRow :appointments-access-code-data="appointments_access_code"></AppointmentsAccessCodesTableRow>
                  </tr>
                </tbody>
              </table>

              <!-- Vets availability -->
              
              <VetsAvailabilityTable
                ref="vetAvailTableRef"
                v-if="getMngMode == 'vets_availability' && !getShowingAppointmentData"
                :vetsAvailability="getVetsAvailability"
              />

              <!-- LOGS FILTERS -->
              <div v-if="getMngMode == 'logs'" class="mb-2">

                <!-- LINE 1: ENTITY SELECTOR -->
                <div class="field is-horizontal is-flex-direction-column-mobile">
                  <div class="field-body">
                    <div class="control">
                      <select
                        v-model="filterLogEntity"
                        class="select is-fullwidth px-3 is-size-6 mobile-select"
                      >
                        <option value="" disabled selected>{{ $t('Management.SelectEntity') }}</option>
                        <option
                          v-for="entity in logEntities"
                          :key="entity"
                          :value="entity"
                        >
                          {{ entity }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- LINE 2: DATES + RESET -->
                <div class="field is-horizontal is-flex-direction-column-mobile mt-2">

                  <!-- FROM -->
                  <div class="field-label is-normal">
                    <label class="label">{{ $t('General.From') }}</label>
                  </div>
                  <div class="field-body">
                    <div class="control">
                      <VueDatePicker
                        v-model="filterLogStartDate"
                        model-type="yyyy-MM-dd"
                        auto-apply
                        :enable-time-picker="false"
                        format="yyyy-MM-dd"
                      />
                    </div>
                  </div>

                  <!-- TO -->
                  <div class="field-label is-normal">
                    <label class="label">{{ $t('General.To') }}</label>
                  </div>
                  <div class="field-body">
                    <div class="control">
                      <VueDatePicker
                        v-model="filterLogEndDate"
                        model-type="yyyy-MM-dd"
                        auto-apply
                        :enable-time-picker="false"
                        format="yyyy-MM-dd"
                      />
                    </div>
                  </div>

                  <!-- RESET -->
                  <div class="field-body">
                    <div class="control">
                      <button @click="resetLogFilters" class="button is-light">
                        {{ $t('General.ResetFilter') }}
                      </button>
                    </div>
                  </div>

                </div>

              </div>

              <!-- LOGS LIST -->
              <div class="table-container mb-2"
                  v-if="getMngMode == 'logs'"
                  style="max-height: 410px; overflow-y: auto;">
                
                <table class="table is-fullwidth">
                  <thead>
                    <tr>
                      <th>{{ $t('LogsData.Date') }}</th>
                      <th>{{ $t('LogsData.Operation') }}</th>
                      <th>{{ $t('LogsData.EntityName') }}</th>
                      <th>{{ $t('LogsData.EntityType') }}</th>
                      <th>{{ $t('LogsData.EntityId') }}</th>
                      <th>{{ $t('LogsData.UpdatedByUserName') }}</th>
                      <th>{{ $t('LogsData.UpdatedByUserId') }}</th>
                      <th>{{ $t('LogsData.Details') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="log in filteredLogs" :key="log.log_id">
                      
                      <td>{{ log.changed_at }}</td>

                      <td>{{ log.operation_type }}</td>

                      <!-- USER / ENTITY INFO -->
                      <td>
                        {{
                          log._details.name ||
                          '-'
                        }}
                      </td>
                      
                      <td>{{ log.resource }}</td>

                      <!-- ENTITY ID -->
                      <td>
                        {{
                          log._details.customer_id ||
                          log._details.user_id ||
                          log._details.pet_id ||
                          '-'
                        }}
                      </td>

                      <td>{{ log.last_update_user_name }}</td>
                      
                      <td>{{ log.last_update_user_id }}</td>

                      <td>
                        <pre class="is-size-7">
                          {{ JSON.stringify(log._details, null, 2) }}
                        </pre>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Form to create a new user -->
              <form @submit.prevent="createUserMeth" v-if="creating">
                <div class="header">
                  <h5 class="title is-5" v-if="getMngMode == 'vets'">
                    {{ $t('Management.NewVet') }}
                  </h5>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <label class="label">{{ $t('UserData.Name') }}</label>
                      <div class="control">
                        <input :minlength='2' v-model="newUser.name" class="input" type="text"
                        :placeholder="$t('UserData.NamePlaceholder')" required>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <label class="label">{{ $t('UserData.Email') }}</label>
                      <div class="control">
                        <input v-model="newUser.email" class="input" type="email"
                        :placeholder="replaceSpecialCharacters($t('UserData.EmailPlaceholder'))" required>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <label class="label">{{ $t('UserData.Password') }}</label>
                      <div class="control">
                        <input :minlength='6' v-model="newUser.password" class="input" type="password"
                        :placeholder="$t('UserData.PasswordPlaceholder')" required>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <label class="label">{{ $t('CustomerData.PassConfirmation') }}</label>
                      <div class="control">
                        <input :minlength='6' v-model="newUser.confirmation" class="input" type="password"
                        :placeholder="$t('UserData.PassConfirmationPlaceholder')" required>
                      </div>
                    </div>
                  </div>
                  <div class="column" v-if="getMngMode != 'managers'">
                    <div class="field">
                      <label class="label">{{ $t('UserData.PhoneNumber') }}</label>
                      <div class="control">
                        <input :minlength='6' v-model="newUser.phone" class="input" type="phone"
                        :placeholder="$t('UserData.PhoneNumberPlaceholder')" required>
                      </div>
                    </div>
                  </div>
                  <div class="column" v-if="getMngMode == 'vets'">
                    <div class="field">
                      <label class="label">{{ $t('VetData.Specialty') }}</label>
                      <div class="control">
                        <input :minlength='6' v-model="newUser.specialty" class="input" type="test"
                        :placeholder="$t('VetData.SpecialtyPlaceholder')" required>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field is-grouped is-grouped-right">
                  <p class="control">
                    <button type="submit" class="button is-primary">{{ $t('General.Save') }}</button>
                  </p>
                  <p class="control">
                    <a @click="toggleCreating" class="button is-light">
                      {{ $t('General.Cancel') }}
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import Navbar from "../components/Navbar.vue";
import { Notyf } from "notyf";
import UserTableRow from "../components/UserTableRow.vue";
import ProductTableRow from "../components/ProductTableRow.vue";
import AppointmentsAccessCodesTableRow from "../components/AppointmentsAccessCodesTableRow.vue";
import AppointmentDataForm from "../components/AppointmentDataForm.vue";
import MngAppointmentRecordTableRow from "../components/MngAppointmentRecordTableRow.vue";
import VetsAvailabilityTable from "../components/VetsAvailabilityTable.vue";
import * as XLSX from 'xlsx';

interface MngAppointmentRecord {
    appointment_id: number,
    schedule: string,
    vet_user_id: number,
    vet_name: string,
    customer_user_id: number,
    customer_name: string,
    pet_id: number,
    pet_name: string,
    pet_policy: string,
    description: string,
    price: number,
    appointment_status: string,
    status_date: string
}

interface Log {
  log_id: number
  resource: string
  operation_type: string
  changed_at: string
  last_update: string
  last_update_user_id: number
  last_update_user_name: string
  details: string | null
}


const notyf = new Notyf()

export default defineComponent({
  name: "Management",
  components: { UserTableRow, Navbar, MngAppointmentRecordTableRow, AppointmentDataForm, ProductTableRow, AppointmentsAccessCodesTableRow, VetsAvailabilityTable },

  data() {
    return {
      componentName: "Management",
      vetAvailTableRef: null,
      creating: false,
      newUser: {
        user_id: 0,
        name: '',
        email: '',
        password: '',
        confirmation: '',
        phone: '',
        specialty: '',
        type: '',
        last_update_user_id: 0
      },
      filterStartDate: '',
      filterEndDate: '',
      filterVetUserId: '',
      considerInsurance: process.env.VUE_APP_CONSIDER_INSURANCE === "true",
      useAppointsAccessCodes: process.env.VUE_APP_USE_APPOINTS_ACCESS_CODES === "true",
      filterLogStartDate: '',
      filterLogEndDate: '',
      filterLogEntityName: '',
      filterLogEntity: '',
      customerNameSearch: '',
    }
  },
  computed:
  {
    ...mapGetters(['getUsers', 'getMngMode', 'getAccessType', 'getShowingAppointmentData', 'getMngAppointmentsRecord', 'getProducts',
                   'getAppointmentsAccessCodes', 'getVetsAvailability', 'getUserData', 'getLogs']),

    filteredUsers()
    {
      if (this.getMngMode !== 'customers') {
        return this.getUsers
      }

      const search = this.customerNameSearch.trim().toLowerCase()

      if (!search) {
        return this.getUsers
      }

      return this.getUsers.filter((user: any) =>
        user.name?.toLowerCase().includes(search)
      )
    },

    parsedLogs(): (Log & { _details: any })[]
    {
      return this.getLogs.map((log: Log) => {
        let details = {}

        try {
          details = log.details ? JSON.parse(log.details) : {}
        } catch (e) {
          console.warn('Invalid log details JSON', log.details)
        }

        return {
          ...log,
          _details: details
        }
      })
    },

    logEntities(): string[]
    {
      const set = new Set<string>()

      this.parsedLogs.forEach(log => {
        const name =
          log._details?.name ||
          log._details?.designation ||
          null

        if (name) {
          set.add(name)
        }
      })

      return Array.from(set).sort()
    },

    filteredLogs(): (Log & { _details: any })[]
    {
      return this.parsedLogs.filter(log => {

        const logDate = new Date(log.changed_at)

        const start = this.filterLogStartDate
          ? new Date(this.filterLogStartDate)
          : null

        const end = this.filterLogEndDate
          ? new Date(this.filterLogEndDate)
          : null

        const entityName =
          log._details?.name ||
          log._details?.designation ||
          ''

        const entityMatch = this.filterLogEntity
          ? entityName === this.filterLogEntity
          : true

        return (
          entityMatch &&
          (!start || logDate >= start) &&
          (!end || logDate <= end)
        )
      })
    },

    validPassword(): boolean
    {
      return (this.newUser.password === this.newUser.confirmation && this.newUser.password.length >= 6)
    },
    
    // Compute maxDate as today plus one month
    maxDate(): Date
    {
      const today = new Date();
      const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
      return nextMonth;
    },
      
    filteredAppointments(): MngAppointmentRecord[]
    {
      return (this.getMngAppointmentsRecord as MngAppointmentRecord[]).filter(
        (appointment: MngAppointmentRecord) =>
        {
          const appointmentDate = new Date(appointment.schedule);
          const start = this.filterStartDate
            ? new Date(this.filterStartDate)
            : null;
          const end = this.filterEndDate ? new Date(this.filterEndDate) : null;
          const vetFilter = this.filterVetUserId
            ? appointment.vet_user_id === Number(this.filterVetUserId)
            : true;

          return (
            vetFilter &&
            (!start || appointmentDate >= start) &&
            (!end || appointmentDate <= end)
          );
        }
      );
    }
  },
  methods: {
    ...mapActions(['createUser',  'iniCustDetailing', 'toggleShowingUserData', 'toggleCustDetailing', 'toggleShowingPetRecord',
                   'iniMngAppointmentsRecord', 'fetchProducts', 'fetchAppointmentsAccessCodes', 'fetchVetsAvailability', 'checkEmailIsTaken',
                   'fetchLogs']),
    
    exportVetAvailTable() {
      const child = this.$refs.vetAvailTableRef as any;
      if (child && typeof child.exportToExcel === "function") {
        child.exportToExcel();
      } else {
        console.warn("VetAvailabilityTable ref not found or method not available");
      }
    },

    replaceSpecialCharacters(text: string) {
      console.log('Original text:', text);
      // Regular expression to replace '%at%' with '@'
      const replacedText = text.replace('%at%', '@');
      console.log('Replaced text:', replacedText);
      return replacedText;
    },

    async createUserMeth() {
      const checkEmailIsTaken = await this.checkEmailIsTaken(this.newUser.email)
      if (!checkEmailIsTaken)
      {
        if (this.validPassword)
        {
          try {
            this.newUser.last_update_user_id = this.getUserData.id
            const create = await this.createUser({newUser: this.newUser, language: this.$i18n.locale});
            if (create) {
              this.toggleCreating()
              notyf.success(this.$t('UserData.NotyfNewUserAdded'))
            }
          } catch (e) {
            notyf.error(this.$t('UserData.NotyfErrorCreatingUser'))
          }
        } else {
          notyf.error(this.$t('UserData.NotyfErrorPasswordsMismatch'))
        }
      }
      else
      {
        notyf.error(this.$t('CustomerData.NotyfEmailInUse'))
      }
    },
    clearForm() {
      this.newUser = {
        user_id: 0,
        name: '',
        email: '',
        password: '',
        confirmation: '',
        phone: '',
        specialty: '',
        type: '',
        last_update_user_id: 0
      }
    },
    toggleCreating() {
      this.creating = !this.creating
    },

    iniCreating() {
      this.clearForm();
      switch (this.getMngMode) {
        case "vets":
          this.newUser.type = 'vet'
          break;
        case "managers":
          this.newUser.type = 'manager'
          break;
        default:
          this.newUser.type = 'customer'
          break;
      }
      this.toggleCreating();
    },

    showCustomerData(userData: any) {
      userData.update_user_id = this.getUserData.id;
      this.iniCustDetailing(userData);
      this.toggleShowingUserData(false);
      //this.toggleCustDetailing(false);
      const language = this.$i18n.locale;
      const accessType = this.getAccessType;
      this.$router.push({ path: "/customerdata", query: { lang: language, access: accessType } });
    },

    resetFilter()
    {
      // Set filter dates to 15 days before and after today
      const today = new Date();
      const fifteenDays = 15;

      // Start date: 15 days before today
      const startDate = new Date(today);
      startDate.setDate(today.getDate() - fifteenDays);
      this.filterStartDate = startDate.toISOString().split('T')[0]; // Format as yyyy-MM-dd

      // End date: 15 days after today
      const endDate = new Date(today);
      endDate.setDate(today.getDate() + fifteenDays);
      this.filterEndDate = endDate.toISOString().split('T')[0]; // Format as yyyy-MM-dd

      // Reset vet filter
      this.filterVetUserId = '';
    },

    resetLogFilters()
    {
      const today = new Date()

      const start = new Date(today)
      start.setDate(today.getDate() - 15)

      const end = new Date(today)
      end.setDate(today.getDate() + 1)

      this.filterLogStartDate = start.toISOString().split('T')[0]
      this.filterLogEndDate = end.toISOString().split('T')[0]
      this.filterLogEntity = ''
    },

    exportAppointmentsToExcel() {
      // Collect the appointment data
      const appointments = this.filteredAppointments;

      // Translate field names
      const translatedFields = {
        appointment: this.$t('AppointmentData.Appointment'),
        vet: this.$t('AppointmentData.Vet'),
        customer: this.$t('AppointmentData.Customer'),
        pet: this.$t('AppointmentData.Pet'),
        policy: this.$t('AppointmentData.Policy'),
        price: this.$t('AppointmentData.Price'),
        status: this.$t('AppointmentData.Status'),
        statusTime: this.$t('AppointmentData.StatusTime')
      };

      // Select specific fields to export with translated names
      const selectedFields = appointments.map(appointment => {
        // Create a row with translated field names
        let row = {
          [translatedFields.appointment]: appointment.schedule,
          [translatedFields.vet]: appointment.vet_name,
          [translatedFields.customer]: appointment.customer_name,
          [translatedFields.pet]: appointment.pet_name,
        };

        // Add policy **right after pet** if insurance is considered
        if (this.considerInsurance) {
          row[translatedFields.policy] = appointment.pet_policy;
        }

        // Continue adding other fields
        return {
          ...row,
          [translatedFields.price]: { v: appointment.price, t: 'n' },
          [translatedFields.status]: appointment.appointment_status,
          [translatedFields.statusTime]: appointment.status_date,
        };
      });
    

      // Convert data to worksheet
      const worksheet = XLSX.utils.json_to_sheet(selectedFields);

      // Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Appointments');

      // Generate current date and time string in format yyyyMMddHHmmss
      const now = new Date();
      const dateTimeString = now.getFullYear().toString() +
                             (now.getMonth() + 1).toString().padStart(2, '0') +
                             now.getDate().toString().padStart(2, '0') +
                             now.getHours().toString().padStart(2, '0') +
                             now.getMinutes().toString().padStart(2, '0') +
                             now.getSeconds().toString().padStart(2, '0');

      // Translate "appointments"
      const translatedAppointments = this.$t('Management.Appointments');

      // Generate Excel file and trigger download with prefixed date-time
      XLSX.writeFile(workbook, `${dateTimeString}_${translatedAppointments}.xlsx`);
    }

  },
  watch:
  {
    getMngMode()
    {
      this.customerNameSearch = ''
    }
  },

  mounted() {
  },


  beforeMount() {
    this.toggleShowingUserData(true);
    this.toggleShowingPetRecord(true);
    this.toggleCustDetailing(true);
    console.log("beforeMount");
  },
  async created() {
    const language = this.$i18n.locale;
    await this.iniMngAppointmentsRecord(language);
    // Set initial filter
    this.resetFilter();
    await this.fetchProducts(language);
    await this.fetchLogs();
    this.resetLogFilters();
    if (this.useAppointsAccessCodes)
    {
      await this.fetchAppointmentsAccessCodes();
    }
    await this.fetchVetsAvailability();
    
    console.log("end of created hook");
  }
})
</script>

<style scoped>
.content-body {
  margin-top: 10px;
}

.sticky-header {
  position: sticky;
  top: 0; /* stick to the top */
  background: white; /* avoid transparency */
  z-index: 10; /* keep above content */
  padding: 0.5rem 0;
}

.scroll-area {
  max-height: 520px;
  overflow-y: auto;
}

@media screen and (max-width: 768px) {
  .field-body {
    margin-bottom: 10px; /* Adjust as needed */
  }
  .mobile-select {
    font-size: 0.875rem !important;  /* is-size-7 equivalent */
    padding: 0.5rem;  /* Adjust padding if needed */
  }
  .mobile-select option {
    font-size: 0.75rem !important; /* Adjust option font size */
    padding: 0.5rem 1rem; /* Optional: Add padding to make options easier to click */
  }
}
</style>
